import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getRoles: EvokeAction<AppState, AppActions> = async store => {
  try {
    const roles = await api.get("roles");
    await store.update(state => {
      state.roles = roles;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getRolesForUser: EvokeAction<AppState, AppActions> = async store => {
  try {
    const userRoles = await api.get(`roles/common`);
    await store.update(state => {
      state.rolesForUser = userRoles;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const createRole: EvokeAction<AppState, AppActions> = async (
  store,
  values: object
) => {
  try {
    let userDetails = store.getState("auth");
    let storeId = userDetails.user.store_id;
     const createdRole = await api.post(
      `stores/${storeId}/roles`,
        {},
      values
    );
    if (!createdRole.error) {
      await store.update(state => {
        if (state.roles !== undefined) {
          state.roles[createdRole.role_id] = createdRole;
        }
      });
    }
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

const updateRole: EvokeAction<AppState, AppActions> = async (
  store,
  role_id:number,
  values: object
) => {
  try {
    let userDetails = store.getState("auth");
    let storeId = userDetails.user.store_id;
     await api.patch(
      `stores/${storeId}/roles/${role_id}`,
        {},
      values
    );
    // if (!updatedRole.error) {
    //   await store.update(state => {
    //     if (state.roles !== undefined) {
    //       state.roles[updatedRole.id] = updatedRole;
    //     }
    //   });
    // }
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};



export const roleActions = {
  getRoles,
  createRole,
  updateRole,
  getRolesForUser
};
